// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file bundles/v1/commerce.proto (package bundles.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Integration, IntegrationJson, Product, ProductJson } from "../../products/v1/product_pb";
import { file_products_v1_product } from "../../products/v1/product_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bundles/v1/commerce.proto.
 */
export const file_bundles_v1_commerce: GenFile = /*@__PURE__*/ fileDesc("ChlidW5kbGVzL3YxL2NvbW1lcmNlLnByb3RvEgpidW5kbGVzLnYxImQKDENvbW1lcmNlRGF0YRItCgtpbnRlZ3JhdGlvbhgBIAEoCzIYLnByb2R1Y3RzLnYxLkludGVncmF0aW9uEiUKB3Byb2R1Y3QYAiABKAsyFC5wcm9kdWN0cy52MS5Qcm9kdWN0YgZwcm90bzM", [file_products_v1_product]);

/**
 * @generated from message bundles.v1.CommerceData
 */
export type CommerceData = Message<"bundles.v1.CommerceData"> & {
	/**
	 * @generated from field: products.v1.Integration integration = 1;
	 */
	integration?: Integration | undefined;

	/**
	 * @generated from field: products.v1.Product product = 2;
	 */
	product?: Product | undefined;
};

/**
 * @generated from message bundles.v1.CommerceData
 */
export type CommerceDataJson = {
	/**
	 * @generated from field: products.v1.Integration integration = 1;
	 */
	integration?: IntegrationJson;

	/**
	 * @generated from field: products.v1.Product product = 2;
	 */
	product?: ProductJson;
};

/**
 * Describes the message bundles.v1.CommerceData.
 * Use `create(CommerceDataSchema)` to create a new message.
 */
export const CommerceDataSchema: GenMessage<CommerceData, { jsonType: CommerceDataJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_commerce, 0);
